import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { useTranslation } from "next-i18next";
import { forwardRef, useImperativeHandle, useState } from "react";

export type PreviewDocumentDialogShowArgs = {
	url: string;
	className?: string;
};

export type PreviewDocumentDialogHandle = {
	show: (args: PreviewDocumentDialogShowArgs) => void;
	close: () => void;
};

export const PreviewDocumentDialog = forwardRef<PreviewDocumentDialogHandle>((_props, ref) => {
	const { t } = useTranslation();

	const [open, setOpen] = useState(false);
	const [options, setOptions] = useState<PreviewDocumentDialogShowArgs | null>(null);
	useImperativeHandle(
		ref,
		() => ({
			show: (args: PreviewDocumentDialogShowArgs) => {
				setOptions(args);
				setOpen(true);
			},
			close: () => {
				handleCloseInternal();
			},
		}),
		[],
	);

	const handleCloseInternal = () => {
		setOpen(false);
		setOptions(null);
	};

	return (
		<Dialog
			open={open}
			data-testid="confirmation-dialog"
			aria-describedby="alert-dialog-description"
			fullWidth
			maxWidth="lg">
			<DialogContent>
				{options && (
					<iframe
						src={options.url}
						title="Document Preview"
						width="100%"
						height="600px"
						style={{ border: "none" }}
					/>
				)}
			</DialogContent>
			<DialogActions>
				<Button
					className="blueButton"
					data-testid="ok-button"
					onClick={handleCloseInternal}
					autoFocus>
					{t("ok")}
				</Button>
			</DialogActions>
		</Dialog>
	);
});
